const fallbackTemporaryStorage = [];

const checkSessionStorageAvailable = () => {
  const testSessionStorage = "testSessionStorage";
  try {
    sessionStorage.setItem(testSessionStorage, testSessionStorage);
    sessionStorage.removeItem(testSessionStorage);
    return true;
  } catch (e) {
    return false;
  }
};

const sessionStorageAvailable = checkSessionStorageAvailable();

const isSessionStorageAvailable = () => sessionStorageAvailable;

export const clearTemporaryValues = () => {
  if (isSessionStorageAvailable()) {
    sessionStorage.clear();
  } else {
    fallbackTemporaryStorage.splice(0, fallbackTemporaryStorage.length);
  }
};

export const setTemporaryInsecureValue = (key, value) => {
  if (isSessionStorageAvailable()) {
    const jsonValue = JSON.stringify(value);
    sessionStorage.setItem(key, btoa(jsonValue));
  } else {
    fallbackTemporaryStorage[key] = JSON.stringify(value);
  }
};

export const getTemporaryInsecureValue = (key) => {
  if (isSessionStorageAvailable()) {
    const temp1 = sessionStorage.getItem(key);
    if (temp1) {
      return JSON.parse(atob(temp1));
    }
    return null;
  }
  const temp2 = fallbackTemporaryStorage[key];
  if (temp2) {
    return JSON.parse(temp2);
  }
  return null;
};
